import {framework_tool, utils_tool, component_tool} from '@/tool'

let {Session} = utils_tool;
import {modelUtils} from '@/utils'

import moment from "moment";
import React from 'react';
import {connect} from 'dva';
import {templateConfig, getTypeValue} from './config'

let {copy} = utils_tool
let {WizCard, WizModal, WizCol, WizRow, WizBrowserExport} = component_tool;
let {WizContainer, WizReduxTemplate} = framework_tool;

const _getValue = (type, key) => {
  const values = {
    bizType: {
      0: '课程',
      1: '考试',
      26: '直播',
      15: '报名',
      45: '班级环节',
      47: '远程评估',
      20: '内容通知'
    },
  }
  return values[type][key]
}


class TaskRecord extends WizContainer {


  constructor(props) {
    super(props);
    const {history} = props;
    let record = {};
    let pageType = 'add'
    // 如果是编辑页面，则缓存来自列表页的这条记录，避免刷新页面之后字段被销毁。
    if (history.location && history.location.pathname === '/taskInfo/record') {
      if (history.location && history.location.record) {
        record = history.location.record;
        Session.set('TaskInfo', record)
      } else {
        record = Session.get('TaskInfo') || {};
      }
      pageType = 'upd';
    }
    this.state = {
      record: record,
      initialValue: {}
    }
    this.pageType = pageType;
  }

  _componentDidMount = () => {

  };

  propsAndStateOnChange = {}

  changeRuleId(data) {
    //this.state.ruleId = data
    this.doAction({
      path: "ruleConfigure/editInfo",
      payload: {
        key: "ruleConfigure@editInfo",
        apiParams: {id: data}
      }
    });
  }


  _timeConvret(time) {
    if (time != null && time != undefined) {
      return moment(time).format("YYYY-MM-DD HH:mm")
    } else {
      return ''
    }
  }

  _renderContentRow(ln, lv = '', rn, rv = '') {
    return (
      <WizRow className='audit-row-item'>
        <WizCol className='col-item' span={3} offset={1}>{ln + '：'}</WizCol>
        <WizCol span={6}>{lv}</WizCol>
        <WizCol className='col-item' span={3} offset={2}>{rn + '：'}</WizCol>
        <WizCol span={9}>{rv}</WizCol>
      </WizRow>
    )
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '执行人',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '执行状态',
        field: 'executeState',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '开始时间',
        field: 'startDate',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '完成时间',
        field: 'endDate',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '是否有效',
        field: 'enableState',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if (o['success']) {
      let data = o['data']
      let taskInfo = data['taskInfo']
      let recordList = data['recordList']
      const bizTypeMap = { '0': '课程', '1': '考试', '26': '直播', '15': '报名','45':'班级环节','47': '远程评估','20':'内容通知' }
      const importanceMap = { '0': '重要', '1': '一般'}

      const executeStateMap = { '0':'未开始','1': '进行中', '2': '已完成'};
      const enableStateMap = { '0': '无效', '1': '有效'}

      let str = '活动名称：' + taskInfo['name'] + '\n'
        + '任务时间：' + taskInfo['startDate'] + ' - ' + taskInfo['endDate'] + '\n'
        + '业务类型：' + bizTypeMap[taskInfo['bizType']] + '\n'
        + '重要程度：' + importanceMap[taskInfo['importance']]

      if(recordList && recordList instanceof Array && recordList.length>0){
        recordList.forEach(p=>{
          p['executeState'] =  executeStateMap[p['executeState']]
          p['enableState'] = enableStateMap[p['enableState']]
        })
      }
      WizBrowserExport({
        title: str,
        sheetName: '任务记录',
        columns: columnDefs.filter((_, index) => index),
        rows: recordList,
        filename: '任务记录.xlsx',
        titleParams: {
          alignment: {vertical: 'bottom', horizontal: 'left', wrapText: true},
          style: {
            alignment: {vertical: "bottom", horizontal: "left", wrapText: true},
          },
          font: {},
        },
        titleRow: {
          height: 60
        }
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    const {record} = this.state
    let taskId = record && record['id'] || 0
    let componentName = 'taskRecord'
    const apis = {
      list: {
        path: `${componentName}/listByPage`,
        payload: {
          key: `${componentName}@listByPage`,
          apiParams: {taskId: taskId}
        }
      },
      export: {
        path: `${componentName}/export`,
        payload: {
          key: `${componentName}@export`,
          apiParams: {taskId: taskId}
        }
      }

    }

    let reduxTemplateCofig = (args) => {
      return {
        apis,
        componentName,
        initApiKeys: ['list'],
        needLoading: true,
        keepInitApiParams: true,
        ...args
      }
    };
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig,
      apiDataFormat: {
        export:this._handleFile,
      },
    })



    return (
      <>
        <WizCard title={'任务模版信息'}>
          {this._renderContentRow('任务名称', `${record['name']}`, '任务时间', `${this._timeConvret(record['startDate'])}~${this._timeConvret(record['endDate'])}`)}
          {this._renderContentRow('业务类型', _getValue("bizType",record['bizType']), '重要程度', `${getTypeValue(`importance`, record['importance'])}`)}
        </WizCard>
        <WizCard title={'任务记录'}>
          <WizReduxTemplate {..._reduxTemplateCofig} />
        </WizCard>
      </>
    );
  }
}


const mapStateToProps = (state, ownProps) => {
  const {taskRecord} = state;
  const load = modelUtils.getLoadingState(state, "taskRecord");
  return {
    ...load
  };
};

export default connect(mapStateToProps)(TaskRecord);
